import utils from 'utils'

export default class addReceiverDialogCtrl {
    constructor($scope, $uibModalInstance, httpRequest, formvalidateApi, receiver, logger) {
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        function init() {
            $scope.receiver = {
                addressInfo: '', // 详细地址
                consigneeName: '', // 收货人 ,
                defaultFlag: 0, // 是否默认:0-否，1-是
                mobile: '', // 手机号
                phone: '', // 固定电话
                zipCode:'',//邮编
            }
            if (receiver) {
                $scope.isEdit = true
                Object.assign($scope.receiver, receiver)
            }
        }

        $scope.validateRules = {
            mobile: [{
                erromsg: '手机号码格式不正确',
                condition(value) {
                    return !utils.regExpTest(value, 'mobile')
                },
            }],
            phone: [{
                erromsg: '固定电话格式不正确',
                condition(value) {
                    return value && !/^[-_\d]*$/g.test(value)
                },
            }],
            zipCode: [{
                erromsg: '邮政编码格式不正确',
                condition(value) {
                    return value && ! /^[1-9][0-9]{5}$/.test(value)
                },
            }],
        }

        init()

        $scope.ok = function ok() {
            const flag = formvalidateApi.run('', true)
            if (!flag) {
                return
            }
            if ($scope.isEdit) {
                httpRequest.post_updateConsignee($scope.receiver).then((res) => {
                    logger.logSuccess('更新收货人地址成功')
                    $uibModalInstance.close(res.data.value)
                })
            } else {
                httpRequest.post_addConsignee($scope.receiver).then((res) => {
                    logger.logSuccess('新增收货人地址成功')
                    $uibModalInstance.close(res.data.value)
                })
            }
        }
    }
}
addReceiverDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'formvalidateApi', 'receiver', 'logger']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/addReceiverDialogCtrl.js